import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../../context/ThemeContext';
import { Users, DollarSign, UserPlus, TrendingUp } from 'lucide-react';

const ActivityFeed = () => {
  const { isDarkMode } = useTheme();
  const activities = [
    { type: 'user', message: 'Nuevo usuario registrado', user: 'Ana García', time: 'Hace 2 min', icon: UserPlus, color: 'text-blue-500' },
    { type: 'commission', message: 'Comisión procesada', amount: 150, user: 'Carlos López', time: 'Hace 5 min', icon: DollarSign, color: 'text-green-500' },
    { type: 'team', message: 'Nuevo miembro en equipo', user: 'María Rodríguez', team: 'Equipo Diamante', time: 'Hace 12 min', icon: Users, color: 'text-purple-500' },
    { type: 'growth', message: 'Crecimiento del equipo', growth: '+5%', team: 'Nivel 2', time: 'Hace 25 min', icon: TrendingUp, color: 'text-orange-500' },
    { type: 'commission', message: 'Comisión procesada', amount: 75, user: 'Juan Pérez', time: 'Hace 35 min', icon: DollarSign, color: 'text-green-500' }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      className={`${isDarkMode ? 'bg-gray-800/80' : 'bg-white/80'} backdrop-blur-sm rounded-3xl p-6 border ${isDarkMode ? 'border-gray-700/50' : 'border-gray-200/50'} shadow-sm`}
    >
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>Actividad Reciente</h3>
          <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Eventos recientes del sistema</p>
        </div>
        <div className={`text-sm ${isDarkMode ? 'text-orange-400' : 'text-orange-600'} font-medium`}>Ver todo</div>
      </div>

      <div className="space-y-4">
        {activities.map((activity, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.6 + index * 0.1 }}
            className={`flex items-start space-x-3 p-3 rounded-2xl ${isDarkMode ? 'hover:bg-gray-700/50' : 'hover:bg-gray-50/50'} transition-colors`}
          >
            <div className={`p-2 rounded-xl ${isDarkMode ? 'bg-gray-700' : 'bg-gray-100'} ${activity.color}`}>
              <activity.icon className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-medium ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>
                {activity.message}
              </p>
              <div className="flex items-center space-x-2 mt-1">
                <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{activity.user}</span>
                {activity.amount && (
                  <span className="text-xs font-medium text-green-600">
                    +${activity.amount}
                  </span>
                )}
                {activity.growth && (
                  <span className="text-xs font-medium text-orange-600">
                    {activity.growth}
                  </span>
                )}
              </div>
            </div>
            <div className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-400'} whitespace-nowrap`}>
              {activity.time}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ActivityFeed;